import { BaseDecisionTreeViewerApi } from "./base";

class StateApi extends BaseDecisionTreeViewerApi {
  constructor() {
    super({ baseURL: "/us_states" });
  }
}

let api;

export const createStateApi = () => {
  api ??= new StateApi();

  return {
    all: async () => api.get(),
  };
};
